export default __webpack_public_path__ + "static/media/logo.cbad883c.svg";